import {useContext, useState} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'

import {TransactionContentCardAdSkeleton} from './TransactionContentCardAdSkeleton.js'

// temporary component, will be moved as a full-featured component
// eslint-disable-next-line react/prop-types
export const TransactionContentAd = ({adId}) => {
  const [adInfo, setAdInfo] = useState({
    data: {
      attributes: [],
      image: '',
      isFavorite: null,
      title: '',
      price: null
    },
    error: null
  })
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const emptyVehicleImage = config.get('technicalDetails').TECHNICAL_DETAILS_EMPTY_VEHICLE_IMAGE
  const defaultImage = `${urlStatics}${emptyVehicleImage}`

  const getAdDetails = async adId => {
    const [adDetailsError, adDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})
    if (adDetailsError) setAdInfo({data: {}, error: true})
    else {
      const {ad} = adDetailsResponse
      const attributes = [
        {key: 'place', value: ad.province},
        {key: 'fuel', value: ad.fuelType},
        {key: 'year', value: ad.year},
        {key: 'kilometers', value: `${ad.km ? i18n.n(ad.km) : 'N/D'} km`}
      ]
      setAdInfo({
        data: {
          attributes: attributes || [],
          image: ad.photos[0] || defaultImage,
          isFavorite: ad.isFavorite,
          title: ad.title || '',
          price: ad.price || null
        },
        error: false
      })
    }
  }

  const showAdInfo = adInfo.error !== null && adInfo.error !== true

  useMount(() => {
    getAdDetails(adId)
  })

  return (
    <div className="mt-TransactionModal-contentAd-modalContainer">
      {showAdInfo ? (
        <div className="mt-TransactionModal-contentAd-modalContent">
          <div className="mt-TransactionModal-contentAd-modalAdInfo">
            <div className="mt-TransactionModal-contentAd-modalImage">
              <AtomImage src={adInfo.data.image} alt={adInfo.data.title} />
            </div>
            <span className="mt-TransactionModal-contentAd-modalTitle">{adInfo.data.title}</span>
            <span className="mt-TransactionModal-contentAd-modalPrice">{i18n.c(adInfo.data.price)}</span>
            <ul className="mt-TransactionModal-contentAd-modalAttributes">
              {adInfo.data.attributes.filter(Boolean).map(
                (attribute, index) =>
                  Boolean(attribute.value) && (
                    <li
                      className="mt-TransactionModal-contentAd-modalAttributesItem"
                      key={`${attribute.value}-${index}`}
                    >
                      {attribute.value}
                    </li>
                  )
              )}
            </ul>
          </div>
        </div>
      ) : (
        <div className="mt-TransactionModal-contentAd-modalContent">
          <div className="mt-TransactionModal-contentAd-modalAdInfo">
            <TransactionContentCardAdSkeleton />
          </div>
        </div>
      )}
    </div>
  )
}

TransactionContentAd.displayName = 'TransactionContentAd'
